import Snackbar from "@material-ui/core/Snackbar";
import makeStyles from "@material-ui/styles/makeStyles";
import React from "react";

export interface AnchorOrigin {
  vertical: "bottom" | "top";
  horizontal: "center" | "left" | "right";
}
interface WarningModelProps {
  error: any;
  onClose: () => void;
  modelStyles?: any;
  anchorOrigin?: AnchorOrigin;
  autoHideDuration?: number;
}

const useStyles = makeStyles(() => {
  return {
    rootClass: {
      "& div": {
        backgroundColor: "#00b38e",
        fontSize: "14px",
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.43,
        letterSpacing: "normal",
        whiteSpace: "pre-line",
      },
    },
  };
});

const WarningModel = (props: WarningModelProps) => {
  const classes = useStyles({});
  const { modelStyles = {}, anchorOrigin, autoHideDuration = 10000 } = props;
  return (
    <Snackbar
      classes={{
        root: classes.rootClass,
      }}
      anchorOrigin={
        anchorOrigin || {
          vertical: "top",
          horizontal: "left",
        }
      }
      style={{ ...modelStyles }}
      open={Boolean(props.error)}
      autoHideDuration={autoHideDuration}
      onClose={props.onClose}
      message={Boolean(props.error) ? props.error.message : null}
      action={
        <React.Fragment>
          <img
            src={`${process.env.NEXT_PUBLIC_247_CDN_URL}/images/ic_cancel_green.svg`}
            alt="cancel"
            style={{
              height: 18,
              width: 18,
              position: "relative",
              marginLeft: 12,
              marginRight: 10,
              cursor: "pointer",
            }}
            onClick={() => {
              props.onClose();
            }}
          />
        </React.Fragment>
      }
    />
  );
};

export default WarningModel;
